import { CTAButtonTypes } from '../../../../components/ctaButton/CTAButtonTypes';
import { StorageTipsTypes } from '../../../storageTipsPage';
export namespace FaqTypes {
  export interface IFaqSection {
    title: string;
    theme?: 'light' | 'dark';
    compactMode: boolean;
    callToAction: CTAButtonTypes.TCallToAction;
    categories: TCategory[];
    variant?: TFAQVariants;
    accordionConfig?: StorageTipsTypes.TAccordionConfig;
  }

  export type TCategoryConfig = {
    title: string;
    content: string[];
  };

  export type TAccordionContentConfig = {
    title: string;
    content: string[];
  };

  export type TSectionHelper = {
    question: string;
    answer: string;
  };

  export type TCategory = {
    categoryName?: string;
    content: TContent[];
  };

  export type TContent = {
    id: number;
    question: string;
    answer: string; //HTML String
    showInCompactMode?: boolean;
  };

  export type TColorConfig = {
    textColor?: TColorType;
    backgroundColor?: TColorType;
  };

  export type TFAQVariants =
    | 'FaqWithQuestionHighlighted'
    | 'FaqWithAnswerHighlighted'
    | string;

  export type TColorTheme = {
    titleSectionColor?: TSectionConfig;
    categoryNameColor?: TColorType;
  };

  export type TSectionConfig = {
    textColor?: TColorType;
    showBorders?: boolean;
  };

  export type TColorType = 'primary' | 'secondary' | string;
}
